import React from 'react';

const Terms = () => (
  <div style={{maxWidth: 700, margin: '40px auto', padding: 24, background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px #eee'}}>
    <h1 style={{color: '#203a43', fontSize: 32, marginBottom: 16}}>Terms & Conditions</h1>
    <p style={{fontSize: 18, color: '#444', marginBottom: 28}}>
      Welcome to ZaziApp. By using our platform, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
    </p>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>Use of Service</h2>
    <ul style={{fontSize: 17, color: '#555', marginBottom: 28, paddingLeft: 24}}>
      <li>You must use ZaziApp for lawful purposes only.</li>
      <li>You agree not to misuse or attempt to disrupt our services.</li>
      <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
    </ul>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>Intellectual Property</h2>
    <ul style={{fontSize: 17, color: '#555', marginBottom: 28, paddingLeft: 24}}>
      <li>All content, trademarks, and data on ZaziApp are the property of ZaziApp or its licensors.</li>
      <li>You may not copy, reproduce, or distribute any part of our platform without permission.</li>
    </ul>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>Limitation of Liability</h2>
    <ul style={{fontSize: 17, color: '#555', marginBottom: 28, paddingLeft: 24}}>
      <li>ZaziApp is provided as-is, without warranties of any kind.</li>
      <li>We are not liable for any damages or losses resulting from your use of the platform.</li>
    </ul>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>Changes to Terms</h2>
    <p style={{fontSize: 17, color: '#555', marginBottom: 16}}>
      We may update these terms from time to time. Continued use of ZaziApp means you accept any changes.
    </p>

    <div style={{marginTop: 24, background: '#f9f9f9', padding: 18, borderRadius: 8, color: '#203a43', fontWeight: 500, fontSize: 16}}>
      <span role="img" aria-label="info">ℹ️</span> If you have any questions about these terms, contact us at <a href="mailto:your-email@example.com" style={{color: '#2a5298'}}>your-email@example.com</a>.
    </div>
  </div>
);

export default Terms;
